import api from './api';

const authService = {
  login(credentials) {
    return api.post('/auth/login/', credentials);
  },

  login2FA(data) {
    return api.post('/auth/login/2fa/', data);
  },

  register(token, data) {
    return api.post('/auth/register/', { ...data, invitation_token: token });
  },

  logout(refreshToken) {
    return api.post('/auth/logout/', { refresh: refreshToken });
  },

  refreshToken(token) {
    return api.post('/auth/token/refresh/', { refresh: token });
  },

  setup2FA() {
    return api.post('/auth/2fa/setup/');
  },

  verify2FA(code) {
    return api.post('/auth/2fa/verify/', { otp_code: code });
  },

  challengeMFA(otpCode, accessToken) {
    return api.post('/auth/2fa/challenge/', { otp_code: otpCode }, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  },

  disable2FA(password) {
    return api.post('/auth/2fa/disable/', { password });
  },

  sendLoginOTP(email) {
    return api.post('/auth/otp/send/', { email });
  },

  verifyLoginOTP(otpToken, code) {
    return api.post('/auth/otp/verify/', { otp_token: otpToken, code });
  },

  forgotPassword(email) {
    return api.post('/auth/forgot-password/', { email });
  },

  resetPassword(token, newPassword) {
    return api.post('/auth/reset-password/', {
      token,
      new_password: newPassword,
      confirm_password: newPassword,
    });
  },

  changePassword(data) {
    return api.post('/auth/change-password/', data);
  },

  getMe() {
    return api.get('/auth/me/');
  },

  completeProfile(data) {
    return api.post('/auth/complete-profile/', data);
  },

  getProfile() {
    return api.get('/users/profile/');
  },

  updateProfile(data) {
    return api.patch('/auth/profile/', data);
  },
};

export { authService };
export default authService;
